// extracted by mini-css-extract-plugin
export default {"casaLoader":"CasaLoader_casaLoader__BM9G8"};